import { FormControl } from "@angular/forms";
import { DynamicFieldType } from "../../enumerators/dynamic-field.enum";
import { DynamicValidation } from "./dynamic-validation";
import { Observable } from "rxjs";


export abstract class DynamicField<T> {
    type: DynamicFieldType;
    label: string;
    labelProperty!: keyof T;
    property!: keyof T;
    validation?: <T, U>(param: T | void) => U | void;
    process?: <T, U>(param: T | void) => U | void;
    preProcess?: <T, U>(param: T | void) => U | void;
    onChange?: <T, U>(param: T | void) => U | void;
    canShow?: <T, U>(param: T | void) => U | void;

    placeholder?: string;
    depensOn?: string;
    depends?: string;
    model?: Object;
    sourceKey?: string;
    autofocus?: boolean;
    keyName?: string;
    disabled?: boolean;
    hidden?: boolean;
    required?: boolean;
    value?: any;
    valueFilter?: any;
    valuesFilter?: any;
    validators?: Array<DynamicValidation>;
    formControl?: FormControl;
    formControlIndex!: number;
    errorMessages!: Map<string, string>;
    appendTo?: string;
    classes?: string;
    isFloatLabel?: boolean;
    hiddenObserver?: Observable<boolean>;
    disabledObserver?: Observable<boolean>;
    alias?: string;
    standalone?: boolean;
    showDebug?: boolean;
    styleClass?: string;
    styleClassObserver?: Observable<string>;
    alone?: boolean;
    tabIndex: number;


    constructor() {
        this.type = DynamicFieldType.Text;
        this.label = '';
        this.depensOn = '';
        this.depends = '';
        this.model = '';
        this.sourceKey = '';
        this.autofocus = false;
        this.keyName = '';
        this.disabled = false;
        this.hidden = false;
        this.isFloatLabel = true;
        this.alone = false;
        this.tabIndex = 0;
    }

    /**
     * The function sets up an observer to disable or enable a form control based on the value emitted
     * by the observer.
     * @param observer - An Observable<boolean> that emits boolean values.
     */
    setDisableObserver(observer: Observable<boolean>) {
        this.disabledObserver = observer;
        this.disabledObserver.subscribe(value => {
            this.disabled = value;

            this.disabled ? this.formControl?.disable() : this.formControl?.enable();
        });
    }
}